import apiClient from './client'
import type { Assistant, CreateAssistantRequest } from '@/types/api'

export const assistantsApi = {
  // POST /api/v1/assistants - создать ассистента
  create: async (data: CreateAssistantRequest): Promise<Assistant> => {
    const response = await apiClient.post<Assistant>('/assistants', data)
    return response.data
  },

  // GET /api/v1/assistants/{id} - получить ассистента
  getById: async (id: string): Promise<Assistant> => {
    const response = await apiClient.get<Assistant>(`/assistants/${id}`)
    return response.data
  },

  // GET /api/v1/organizations/{orgId}/assistants - список ассистентов организации
  getByOrganizationId: async (orgId: string): Promise<Assistant[]> => {
    const response = await apiClient.get<Assistant[]>(`/organizations/${orgId}/assistants`)
    return response.data
  },

  // PUT /api/v1/assistants/{id} - обновить ассистента
  update: async (id: string, data: Partial<Assistant>): Promise<Assistant> => {
    const response = await apiClient.put<Assistant>(`/assistants/${id}`, data)
    return response.data
  },

  // POST /api/v1/assistants/{id}/activate - активировать
  activate: async (id: string): Promise<void> => {
    await apiClient.post(`/assistants/${id}/activate`)
  },

  // POST /api/v1/assistants/{id}/deactivate - деактивировать
  deactivate: async (id: string): Promise<void> => {
    await apiClient.post(`/assistants/${id}/deactivate`)
  },

  // DELETE /api/v1/assistants/{id} - удалить ассистента
  delete: async (id: string): Promise<void> => {
    await apiClient.delete(`/assistants/${id}`)
  },

  // PUT /api/v1/organizations/{orgId}/assistants/display-order - обновить порядок
  updateDisplayOrders: async (orgId: string, orders: { assistant_id: string; display_order: number }[]): Promise<void> => {
    await apiClient.put(`/organizations/${orgId}/assistants/display-order`, {
      assistant_orders: orders,
    })
  },
}
